import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=e7fd18fa"
import script from "./ModalComponent.vue?vue&type=script&lang=ts"
export * from "./ModalComponent.vue?vue&type=script&lang=ts"
import style0 from "./ModalComponent.vue?vue&type=style&index=0&id=e7fd18fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports